import React from "react"
import style from "../components/citaatMobile.module.scss"

export default function CitaatMobile({ tekst, auteur }) {
  return (
    <div className={style.wrapper}>
      <div className={style.content}>
        <p className={style.citaat}>{tekst}</p>
        <p className={style.credit}>{auteur}</p>
      </div>
    </div>
  )
}
